"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioSelect = RadioSelect;
var _core = require("@blueprintjs/core");
var _classnames = _interopRequireDefault(require("classnames"));
var React = _interopRequireWildcard(require("react"));
var _classes = require("../../common/classes");
var _FlexItem = require("../layout/FlexItem");
var _Frow = require("../layout/Frow");
var _typography = require("../typography/typography");
var _excluded = ["children", "className", "description", "intent", "label"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function RadioSelect(_ref) {
  var children = _ref.children,
    className = _ref.className,
    description = _ref.description,
    intent = _ref.intent,
    label = _ref.label,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = (0, _classnames.default)(_classes.Classes.intentClass(intent), _classes.Classes.CONTROL_SELECT, className);

  /**
   * Allow for the situation for when there is no label or description provided.
   * This ensures that we can pass completely custom content to the radio select if we want.
   */
  var content;
  if (label && description) {
    content = /*#__PURE__*/React.createElement("span", {
      className: _classes.Classes.CONTROL_LABEL
    }, /*#__PURE__*/React.createElement(_Frow.Frow, {
      flexDirection: "column",
      verticalGutters: 4
    }, /*#__PURE__*/React.createElement(_FlexItem.FlexItem, null, /*#__PURE__*/React.createElement(_typography.Body, null, label)), /*#__PURE__*/React.createElement(_FlexItem.FlexItem, null, /*#__PURE__*/React.createElement(_typography.Caption, null, description))));
  } else if (label) {
    content = /*#__PURE__*/React.createElement("span", {
      className: _classes.Classes.CONTROL_LABEL
    }, label);
  }
  return /*#__PURE__*/React.createElement(_core.Radio, _extends({
    className: classes
  }, props), children, content, /*#__PURE__*/React.createElement("div", {
    className: _classes.Classes.CONTROL_FILL
  }));
}